import React, { useState } from "react";
import DTOOvertimeARModal from "./DTOOvertimeARModal";
import OvertimeARModalPresenter from "./OvertimeARModalPresenter";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import { useAppSelector } from "../../../../infra/hooks";
import { actionRequiredService } from "../../../../api/services/actionRequiredService";

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  fullData?: any;
  historyData?: any;
}

const OvertimeARModalController = ({
  isModalOpen,
  closeModal,
  fullData,
  historyData,
}: ModalInterface) => {
  const { t } = useTranslation();
  const selector = useAppSelector((state) => state.authSlice);
  const [allActions, setAllActions] = useState([]);
  const hitAction = (payload: any) => {
    actionRequiredService
      .finalActionSubmitActionRequired(payload)
      .then((res: any) => {
        if (res?.response == "success") {
          toast.success("Action Performed Successfully!");
          closeModal();
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.data);
      });
  };
  return (
    <div>
      <DTOOvertimeARModal setAllActions={(act: any) => setAllActions(act)} />

      <OvertimeARModalPresenter
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        trans={t}
        fullData={fullData}
        historyData={historyData}
        userId={selector.user_id}
        allActions={allActions}
        handleSubmitAR_Request={hitAction}
      />
    </div>
  );
};

export default OvertimeARModalController;
